import { render } from "./IconMenuProductList.vue?vue&type=template&id=20d22fa0"
import script from "./IconMenuProductList.vue?vue&type=script&lang=ts"
export * from "./IconMenuProductList.vue?vue&type=script&lang=ts"
script.render = render

export default script